/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class MeevoRegisterSignature implements angular.IDirective {
        restrict = 'E';
        template = `<canvas width="{{width}}" height="{{height}}"></canvas>`;
        scope = {
            height: '@',
            width: '@',
            signaturePad: "=?"
        };

        controller = [
            () => {}
        ];

        link = (scope, element, $window) => {
            const canvas = element.find('canvas')[0];
            

	        scope.onResize = () => {
		        const ratio = Math.max($window.devicePixelRatio || 1, 1);
		        canvas.width = canvas.offsetWidth * ratio;
		        canvas.height = canvas.offsetHeight * ratio;
		        canvas.getContext('2d').scale(ratio, ratio);
	        }
            scope.onResize();
            if (device.mobile()) {
                scope.height = 200;
            }

            scope.signaturePad = new window['SignaturePad'](canvas, {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                penColor: 'rgb(0, 0, 0)'
            });

	        angular.element($window).bind('resize', scope.onResize);
        };

        static factory(): angular.IDirectiveFactory {
            const directive = () => {
                return new MeevoRegisterSignature();
            };

            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoRegisterSignature', MeevoRegisterSignature.factory());
}